import React from 'react';

import { withStepsState } from "./../../../shared/containers/containerStepsState"

import { steps } from "./../../../shared/static.steps"

import styles from "./progressSteps.module.scss"

const ProgressSteps = props => {
  const { currentIndex } = props
  const totalSteps = Object.keys(steps).length;

  return (
    <div className={styles.progress} style={{'--step': currentIndex, '--totalSteps': totalSteps}}></div>
  );
}

export default withStepsState(ProgressSteps);